<template>
    <dv-border-box-12>
        <div id="alalysis-container1" class="box1"></div>
    </dv-border-box-12>
</template>

<script>
/* eslint-disable */

import * as echarts from "echarts";
import EventBus from "../js/event-bus.js";
export default {
    name: "AnalysisChart1",
    data() {
        return {
            chartData: null,
        };
    },
    mounted() {
        this.getData();
        EventBus.$on("inventoryChangedEvent", (row) => {
            this.getData();
        });
    },
    methods: {
        getData() {
            this.$api
                .getManufactureMonthly()
                .then((result) => {
                    if (
                        result.ok === true &&
                        result.data &&
                        result.data.length === 3
                    ) {
                        this.chartData = result.data;
                        this.drawLine();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("alalysis-container1")
            );
            // 绘制图表
            myChart.setOption({
                backgroundColor: "transparent",
                // title: {
                //     text: "产废量同比",
                //     textStyle: {
                //         color: "#FFFFFF",
                //         fontSize: "16px",
                //     },
                // },
                tooltip: {
                    trigger: "axis", //触发类型；轴触发，axis则鼠标hover到一条柱状图显示全部数据，item则鼠标hover到折线点显示相应数据，
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    top: 10,
                    textStyle: {
                        fontSize: 10,
                        color: "rgba(255,255,255,.7)",
                    },
                    data: [
                        this.chartData[0].year.toString(),
                        this.chartData[1].year.toString(),
                        this.chartData[2].year.toString(),
                    ],
                },
                grid: {
                    left: 80,
                    right: 0,
                    top: 50,
                    bottom: 40,
                },
                xAxis: [
                    {
                        type: "category",
                        data: [
                            "1月",
                            "2月",
                            "3月",
                            "4月",
                            "5月",
                            "6月",
                            "7月",
                            "8月",
                            "9月",
                            "10月",
                            "11月",
                            "12月",
                        ],
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.2)",
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.1)",
                            },
                        },
                        axisLabel: {
                            color: "rgba(255,255,255,.7)",
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.3)",
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.1)",
                            },
                        },
                        axisLabel: {
                            formatter: "{value} kg",
                        },
                    },
                ],
                series: [
                    {
                        //柱状图-柱子1
                        name: this.chartData[0].year, //需要跟legend配置项对应
                        type: "bar",
                        // itemStyle: {
                        //     borderRadius: [10, 10, 0, 0], //控制柱状图的圆角显示弧度，（顺时针左上，右上，右下，左下）
                        // },
                        data: this.chartData[0].amounts,
                    },
                    {
                        type: "bar",
                        name: this.chartData[1].year,
                        data: this.chartData[1].amounts,
                    },
                    {
                        type: "bar",
                        name: this.chartData[2].year,
                        data: this.chartData[2].amounts,
                    },
                ],
            });
        },
    },
};
</script>

<style lang="less"></style>
